import { Badge as RawBadge } from '@cargomatic/ui';
export const Badge = RawBadge;
